import PrivateApi from "@/services/PrivateApi.js";
import store from "@/store";

export default () => {
  if (store.state.data.loadedPositions) {
    return Promise.resolve(store.state.data.loadedPositions);
  } else {
    var positions = PrivateApi().get("positions");

    positions.then(function(positions) {
      store.commit("setLoadedPositions", positions);
    });

    return Promise.resolve(positions);
  }
};
